(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Touch preview of the second product image — only at desktop width
     (≥990px), for a touch-capable device there (a touchscreen laptop, a
     landscape tablet wide enough to already use the desktop layout):
     resting a finger on the media reveals image 2, exactly like desktop's
     `:hover`. Below 990px this never fires — the native swipe strip
     (see the stylesheet above, .product-card__track) already lets a
     visitor see every image directly, so this preview would only fight
     that gesture. A tap that doesn't move (no scroll intent) still opens
     the product normally through the existing <a> — nothing here ever
     calls preventDefault, so native vertical scroll is never touched, and
     a scroll that starts on a card just cancels the preview instead of
     doing anything else. One delegated listener for every card on the
     page, not one per card. Desktop pointerType is "mouse" and is ignored
     here — that stays on the CSS :hover above. */
  (function () {
    'use strict';
    if (!('PointerEvent' in window) || window.oxalisProductCardTouchBound) return;
    window.oxalisProductCardTouchBound = true;

    var MOVE_THRESHOLD = 10; // px of movement before a touch counts as scrolling, not resting
    var desktopQuery = window.matchMedia('(min-width: 990px)');

    document.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
        if (!desktopQuery.matches) return;
        var media = e.target.closest('.product-card__media');
        if (!media || !media.querySelector('.product-card__img--hover')) return;

        var startX = e.clientX;
        var startY = e.clientY;
        var pointerId = e.pointerId;
        media.classList.add('is-touch-preview');

        function reset() {
          media.classList.remove('is-touch-preview');
          media.removeEventListener('pointermove', onMove);
          media.removeEventListener('pointerup', reset);
          media.removeEventListener('pointercancel', reset);
        }
        function onMove(ev) {
          if (ev.pointerId !== pointerId) return;
          if (Math.abs(ev.clientX - startX) > MOVE_THRESHOLD || Math.abs(ev.clientY - startY) > MOVE_THRESHOLD) {
            reset(); // scrolling, not resting — hand the gesture back to the page
          }
        }

        media.addEventListener('pointermove', onMove, { passive: true });
        media.addEventListener('pointerup', reset, { passive: true });
        media.addEventListener('pointercancel', reset, { passive: true });
      },
      { passive: true }
    );
  })();

  /* ---------------- Quick-add (cart drawer "Complétez la parure") ----------------
     Delegated (not per-card: the drawer's own refresh() swaps the whole
     block's innerHTML on every cart change, which would silently orphan a
     direct listener) so it keeps working after any AJAX refresh without
     needing a re-bind call of its own. A no-op everywhere a card doesn't
     carry [data-quick-add] (every other carousel/grid on the site, since
     this markup only ever renders when quick_add is explicitly passed).
     Two-step for a multi-variant product: first tap reveals the select and
     turns the button into "Valider"; second tap (or picking then tapping)
     adds the currently selected variant. A single-variant product adds on
     the very first tap. Always dispatches the same 'oxalis:cart:add' event
     assets/product.js uses, with detail.silent so assets/cart.js updates
     the drawer's lines/subtotal in place without reopening or re-locking
     it (the drawer is already open) — see assets/cart.js's listener. */
  (function () {
    'use strict';
    if (window.oxalisQuickAddBound) return;
    window.oxalisQuickAddBound = true;

    function setBusy(btn, busy) {
      btn.disabled = busy;
    }

    function flashAdded(btn) {
      var textEl = btn.querySelector('[data-quick-add-text]');
      if (!textEl) return;
      var original = textEl.textContent;
      textEl.textContent = btn.getAttribute('data-label-added') || 'Ajouté ✓';
      btn.classList.add('is-added');
      window.setTimeout(function () {
        textEl.textContent = original;
        btn.classList.remove('is-added');
      }, 1400);
    }

    function addVariant(btn, variantId) {
      var textEl = btn.querySelector('[data-quick-add-text]');
      var original = textEl ? textEl.textContent : '';
      setBusy(btn, true);
      if (textEl) textEl.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (item) {
          setBusy(btn, false);
          if (item && item.id) {
            document.dispatchEvent(
              new CustomEvent('oxalis:cart:add', { detail: { item: item, silent: true } })
            );
            flashAdded(btn);
          } else if (textEl) {
            // Stock/variant error from Shopify (e.g. sold out between page
            // load and tap) — restore the label rather than claim success.
            textEl.textContent = original;
          }
        })
        .catch(function () {
          setBusy(btn, false);
          if (textEl) textEl.textContent = original;
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add-btn]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var wrap = btn.closest('[data-quick-add]');
      var select = wrap ? wrap.querySelector('[data-quick-add-select]') : null;
      var textEl = btn.querySelector('[data-quick-add-text]');

      if (select && select.hidden) {
        select.hidden = false;
        if (textEl) textEl.textContent = btn.getAttribute('data-label-confirm') || 'Valider';
        return;
      }

      var variantId = select ? select.value : btn.getAttribute('data-default-variant-id');
      if (!variantId) return;
      // Reset the resting label to "+ Ajouter" (data-label-add) *before*
      // addVariant captures its own "original" to restore after the
      // confirmation flash — otherwise a multi-variant add would permanently
      // get stuck showing "Valider" once the flash fades.
      if (select) {
        select.hidden = true;
        if (textEl) textEl.textContent = btn.getAttribute('data-label-add') || '+ Ajouter';
      }
      addVariant(btn, variantId);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-bottom"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var btn = document.querySelector('[data-scroll-bottom]');
    if (!btn) return;

    var LONG_PAGE_RATIO = 1.2; // destination must be at least 1.2x the viewport away
    var NEAR_TARGET = 40; // px from the destination where the button hides
    var DIRECTION_DEAD_ZONE = 4; // px of jitter ignored when reading direction
    var FOOTER_MARGIN = 30; // breathing room kept above the footer

    var lastY = window.scrollY || document.documentElement.scrollTop;
    var ticking = false;
    var animating = false;

    function targetY() {
      var footer = document.querySelector('.footer');
      if (footer) {
        return Math.max(0, footer.getBoundingClientRect().top + window.scrollY - FOOTER_MARGIN);
      }
      // Fallback, only if the footer is exceptionally not found.
      return document.documentElement.scrollHeight - window.innerHeight;
    }

    function update() {
      ticking = false;
      if (animating) return; // the button's own scroll is in progress
      var y = window.scrollY || document.documentElement.scrollTop;
      var viewport = window.innerHeight;
      var target = targetY();
      var longEnough = target > viewport * LONG_PAGE_RATIO;
      var nearTarget = y >= target - NEAR_TARGET;

      if (!longEnough || nearTarget) {
        btn.hidden = true;
      } else if (y > lastY + DIRECTION_DEAD_ZONE) {
        btn.hidden = false; // scrolling down
      } else if (y < lastY - DIRECTION_DEAD_ZONE) {
        btn.hidden = true; // scrolling up
      }
      // Otherwise: within the dead zone — leave visibility as it is.

      lastY = y;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', update);

    // Recompute if the page's own content changes height dynamically
    // (AJAX-loaded sections, lazy images resolving, etc.) — coalesced
    // through the same rAF guard above, so this stays cheap. Watching
    // <main> rather than the whole document body is enough (the target,
    // .footer, always sits right after it) and skips reacting to header
    // chrome that changes constantly but never affects this — the nav
    // drawer, search overlay and cart drawer all toggle attributes/content
    // there on every open/close and cart update.
    if ('MutationObserver' in window) {
      var observedRoot = document.querySelector('main') || document.body;
      new MutationObserver(requestUpdate).observe(observedRoot, {
        childList: true,
        subtree: true,
      });
    }

    update();

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    // A short, fast, JS-driven scroll — never the native
    // `behavior: "smooth"` (whose duration scales unpredictably with
    // distance) and never an instant jump. Duration stays short and
    // roughly proportional to distance, capped so a very long page never
    // takes noticeably longer than a shorter one.
    function animateScrollTo(destination) {
      var startY = window.scrollY || document.documentElement.scrollTop;
      var distance = destination - startY;
      if (Math.abs(distance) < 1) return;
      var duration = Math.min(500, Math.max(300, Math.abs(distance) / 4));
      var startTime = null;
      animating = true;

      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min(1, (now - startTime) / duration);
        window.scrollTo(0, startY + distance * easeInOutQuad(progress));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          animating = false;
          lastY = window.scrollY || document.documentElement.scrollTop;
          btn.hidden = true; // destination reached
        }
      }
      window.requestAnimationFrame(step);
    }

    btn.addEventListener('click', function () {
      animateScrollTo(targetY());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vacation-popup"] && !Shopify.designMode) return;
  try {
    (function () {
      'use strict';
      var popup = document.querySelector('[data-vacation-popup]');
      if (!popup) return;

      // Dated key (not just a bare flag) so a visitor who dismissed it
      // during a previous promo/announcement window, if this snippet is
      // ever reused for a future one with different dates, sees the new
      // one fresh rather than inheriting an old dismissal.
      var STORAGE_KEY = 'oxalis-vacation-popup-dismissed-2026-10-18';
      var dismissed = false;
      try {
        dismissed = sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        dismissed = false; // storage blocked (private mode etc.) — fail open, still show it
      }
      if (dismissed) return;

      var panel = popup.querySelector('.vacation-popup__panel');
      var lastFocused = null;

      function trapFocus(e) {
        if (e.key !== 'Tab' || !panel) return;
        var focusable = panel.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      function onKeydown(e) {
        if (e.key === 'Escape') close();
        else trapFocus(e);
      }

      function open() {
        lastFocused = document.activeElement;
        popup.hidden = false;
        requestAnimationFrame(function () {
          popup.setAttribute('data-open', '');
        });
        window.setTimeout(function () {
          if (panel) panel.focus();
        }, 50);
        document.addEventListener('keydown', onKeydown);
      }

      function close() {
        popup.removeAttribute('data-open');
        window.setTimeout(function () {
          popup.hidden = true;
        }, 300);
        document.removeEventListener('keydown', onKeydown);
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {
          /* best effort only — a session without storage just sees it again on reload */
        }
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      popup.querySelectorAll('[data-vacation-popup-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      // Small delay so it never fights the very first paint / layout shift.
      window.setTimeout(open, 400);
    })();
  } catch(e) { console.error(e); }
})();

})();
